

const TeacherCard = ({ teacher, showDetails = true }) => {
  const {
    userId = {},
    designation,
    department,
    qualification,
    experience,
    joiningDate
  } = teacher;

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
      {/* Teacher Image Placeholder */}
      <div className="bg-gray-200 border-2 border-dashed rounded-t-lg w-full h-48 flex items-center justify-center">
        {userId.avatar ? (
          <img 
            src={userId.avatar} 
            alt={userId.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <span className="text-gray-500 text-5xl">👨‍🏫</span>
        )}
      </div>
      
      <div className="p-5">
        <h3 className="text-xl font-bold text-gray-800 mb-1">{userId.name || 'Teacher Name'}</h3>
        
        <p className="text-primary font-medium mb-2">{designation || 'Designation'}</p>
        
        <div className="space-y-1 text-sm text-gray-600">
          <div className="flex items-center">
            <span className="font-medium w-24">Department:</span>
            <span>{department || 'N/A'}</span>
          </div>
          
          <div className="flex items-center">
            <span className="font-medium w-24">Qualification:</span>
            <span>{qualification || 'N/A'}</span>
          </div>
          
          {experience && (
            <div className="flex items-center">
              <span className="font-medium w-24">Experience:</span>
              <span>{experience} years</span>
            </div>
          )}
          
          {joiningDate && (
            <div className="flex items-center">
              <span className="font-medium w-24">Joining:</span>
              <span>{formatDate(joiningDate)}</span>
            </div>
          )}
        </div>
        
        {showDetails && (
          <div className="mt-4 pt-4 border-t">
            <div className="flex items-center text-sm text-gray-600">
              <span className="mr-2">📧</span>
              <span className="truncate">{userId.email || 'N/A'}</span>
            </div>
            
            {userId.phone && (
              <div className="flex items-center text-sm text-gray-600 mt-1">
                <span className="mr-2">📞</span>
                <span>{userId.phone}</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TeacherCard;